import reducer from './projects.reducer';
import actions from './projects.actions';
import selectors from './projects.selectors';

export default {
  reducer,
  actions,
  selectors,
};
